const { getProperty } = require('../PropertyGetter');

const updateHexaOverlaySelectedSwatches = (hexaSwatches, selectedColor) => {
  hexaSwatches.forEach((swatch) => {
    swatch.isSelected = `${swatch.id}` === `${selectedColor}`;
  });
};

const is360Asset = (iFrame = {}) => iFrame.resource_type === 3;
const getColorNameById = (colorMap, id) => getProperty(colorMap, `[${id}].name`, '');

const getHexaOverlaySwatches = (iFramesMap, { colorSwatchTiers, colorMap }) => colorSwatchTiers.reduce((overlaySwatches, swatchTier, tierIndex) => {
  const filteredSwatches = swatchTier.swatches
    .map((swatch, swatchIndex) => ({
      ...swatch,
      tierIndex,
      swatchIndex,
      colorName: getColorNameById(colorMap, swatch.id),
    }))
    .filter(overlaySwatch => iFramesMap[`${overlaySwatch.id}`]);

  overlaySwatches.push(...filteredSwatches);
  return overlaySwatches;
}, []);

const getSelectedHexaFrameData = (hexaData, { selectedColor, colorMap }) => {
  const hexaIframesMap = getProperty(hexaData, 'iFramesMap', {});

  const selectedIFrame = hexaIframesMap[selectedColor] || hexaIframesMap[getProperty(hexaData, 'overlaySwatches[0].id')];
  selectedIFrame.iframeSrc = is360Asset(selectedIFrame) ? selectedIFrame.resource_big : selectedIFrame.resource_default;

  const selectedColorName = getColorNameById(colorMap, selectedIFrame.product_color);
  updateHexaOverlaySelectedSwatches(getProperty(hexaData, 'overlaySwatches', []), selectedIFrame.product_color);

  return {
    selectedColorName,
    selectedIFrame,
  };
};

const getInitialHexaData = (data = [], additionalData) => {
  const iFramesMap = data
    .filter(frame => frame.product_color)
    .reduce((map, frame = {}) => {
      map[frame.product_color] = frame;
      return map;
    }, {});

  const overlaySwatches = getHexaOverlaySwatches(iFramesMap, additionalData);

  return {
    iFramesMap,
    isShowingButton: !!overlaySwatches.length,
    buttonTitle: `See it in ${is360Asset(data[0]) ? '360' : '3D'}`,
    assetType: is360Asset(data[0]) ? '360' : '3d',
    overlaySwatches,
  };
};

module.exports = {
  getInitialHexaData,
  getHexaOverlaySwatches,
  getSelectedHexaFrameData,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/viewState/Hexa.js